import config from '../config';

// Função utilitária para fazer chamadas de API
export const apiCall = async (endpoint, options = {}) => {
  const url = `${config.getApiUrl()}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };

  const finalOptions = {
    ...defaultOptions,
    ...options
  };

  try {
    const response = await fetch(url, finalOptions);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Funções específicas para cada tipo de requisição
export const apiGet = (endpoint) => apiCall(endpoint, { method: 'GET' });

export const apiPost = (endpoint, data) => apiCall(endpoint, {
  method: 'POST',
  body: JSON.stringify(data)
});

export const apiPut = (endpoint, data) => apiCall(endpoint, {
  method: 'PUT',
  body: JSON.stringify(data)
});

export const apiDelete = (endpoint) => apiCall(endpoint, { method: 'DELETE' });

// Função para upload de arquivos
export const apiUpload = async (endpoint, formData) => {
  const url = `${config.getApiUrl()}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData // Não incluir Content-Type para multipart/form-data
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API upload failed:', error);
    throw error;
  }
}; 